import {createSlice} from '@reduxjs/toolkit'
import * as THREE from 'three'

const geometryIntialState = {
    boxGeometry: new THREE.BoxGeometry(1,1,1),
    floor1Material:new THREE.MeshStandardMaterial({color: 'limegreen'}),
    floor2Material:new THREE.MeshStandardMaterial({color: 'greenyellow'}),
    obstacleMaterial:new THREE.MeshStandardMaterial({color: '#ff6347'}),
    wallMaterial:new THREE.MeshStandardMaterial({color: 'slategrey'}),
    blocksCount: 3,
}

const geometrySlice = createSlice({
    name: 'geometry',
    initialState: geometryIntialState,
    reducers:{
        // initialiseGeo: (state, action)=>{
        //     const boxGeometry = new THREE.BoxGeometry(1,1,1)
        //     const floor1Material = new THREE.MeshStandardMaterial({color: 'limegreen'})
        //     const floor2Material = new THREE.MeshStandardMaterial({color: 'greenyellow'})
        //     const obstacleMaterial = new THREE.MeshStandardMaterial({color: 'tomato'})
        //     const wallMaterial = new THREE.MeshStandardMaterial({color: 'slategrey'})

        //     state.boxGeometry = boxGeometry
        //     state.floor1Material = floor1Material
        //     state.floor2Material = floor2Material
        //     state.obstacleMaterial = obstacleMaterial
        //     state.wallMaterial = wallMaterial
        // }
    }
})

export default geometrySlice